import {PaymentMehtodsByCurrency} from "../http/Types";
import {Dispatch} from "redux";
import {AppState} from "../RootReducer";
import {getContainer} from "../ioc/IOCSetup";
import {CashierSection} from "./PaymentsReducer";
import {DepositActionType} from "./DepositActions";
import {PaymentMethod} from "../http/protocol";
import {WithdrawActionType} from "./WithdrawActions";

export enum PaymentActionType {
    PROVIDER_REQUEST = "@payments/provider/request",
    PROVIDER_RESPONSE = "@payments/provider/response",
    PROVIDER_ERROR = "@payments/provider/error",
    RESET = "@payments/withdraw/reset",
    SELECT_GROUP = "@payments/select-group"
}
export type PaymentActions =
    | { type : PaymentActionType.PROVIDER_REQUEST }
    | { type : PaymentActionType.PROVIDER_RESPONSE, methods : PaymentMehtodsByCurrency }
    | { type : PaymentActionType.PROVIDER_ERROR, error : Error }
    | { type : PaymentActionType.SELECT_GROUP, group : string }
    | { type : PaymentActionType.RESET, amount : string, removePreferredForCurrencyCode? : string, section? : CashierSection };


export function fetchProviders() {
    return (dispatch : Dispatch, getState :() => AppState) => {
        if(getState().payments.withdraw.methods) {
            dispatch({ type : PaymentActionType.RESET });
        } else {
            dispatch({type : PaymentActionType.PROVIDER_REQUEST});
            getContainer().getPaymentsService().getPaymentMethods().then( r => {
                dispatch({type : PaymentActionType.PROVIDER_RESPONSE, methods : r})
            }).catch(err => {
                dispatch({ type : PaymentActionType.PROVIDER_ERROR, error : err});
            })
        }
    }
}

export const reset = (removePreferredForCurrencyCode?: string)  => {
    return (dispatch : Dispatch, getState : () => AppState) => {
        dispatch({ type : PaymentActionType.RESET, amount: "", removePreferredForCurrencyCode : removePreferredForCurrencyCode, section : getState().payments.cashier.section });
    }
}
export function selectGroup(group? : string) {
    return { type : PaymentActionType.SELECT_GROUP, group : group };
}
export function selectMethod(method : PaymentMethod, currencyCode? : string) {
    return  (dispatch : Dispatch, getState :() => AppState) : any => {
       if(method.provider && method.code && currencyCode) {
           let section = getState().payments.cashier.section;
           if(section == CashierSection.WITHDRAW) {
               dispatch({type : WithdrawActionType.WITHDRAW_CONTEXT_REQUEST});
               getContainer().getPaymentsService().getWithdrawContext(method.provider, method.code, currencyCode).then((res : any)=>{
                   dispatch({ type : WithdrawActionType.WITHDRAW_CONTEXT_RESPONSE,  context : res, method : method, currencyCode : currencyCode});
               }).catch(err => {
                   dispatch({ type : WithdrawActionType.WITHDRAW_CONTEXT_ERROR })
               });

           } else {
               dispatch({type : DepositActionType.DEPOSIT_CONTEXT_REQUEST});
               return getContainer().getPaymentsService().getDepositContext(method.provider, method.code, currencyCode).then((res : any)=>{
                   dispatch({ type : DepositActionType.DEPOSIT_CONTEXT_RESPONSE,  context : res, method : method, currencyCode : currencyCode });
               }).catch(err => {
                   dispatch({ type : DepositActionType.DEPOSIT_CONTEXT_ERROR })
               });
           }
       }
    }
}